import { GetterTree } from "vuex";
import {
  IProfileState,
  IAuthProfile,
  IProfilePreferencesLegacy,
  ITwoFactorSetup,
} from "@/core/interfaces/profile.interface";
import { StoreState } from "@/store/type";

const getters: GetterTree<IProfileState, StoreState> = {
  authProfile: (state): IAuthProfile | null => state.authProfile,
  isFetchingProfile: (state): boolean => state.isFetchingProfile,
  isUpdatingProfile: (state): boolean => state.isUpdatingProfile,
  isVerifyingAuthenticator: (state): boolean => state.isVerifyingAuthenticator,
  twoFactorSetup: (state): ITwoFactorSetup | null => state.twoFactorSetup,
  preferences: (state): IProfilePreferencesLegacy | null => {
    if (!state.authProfile) return null;
    return {
      contact_number: state.authProfile.contact_number ?? "",
      whatsapp_number: state.authProfile.whatsapp_number ?? "",
      flight_search_pairs_view:
        state.authProfile.flight_search_pairs_view ?? false,
    };
  },
};

export default getters;
